<template>
  <div>
    <div v-for="navMenu in navMenus">
      <div v-if="!navMenu.hidden">
        <!-- 此菜单下还有子菜单 -->
        <el-submenu v-if="navMenu.children && navMenu.children.length > 0 && navMenu.showChild"
                    :key="navMenu.id"
                    :data="navMenu"
                    :index="navMenu.path">
          <template slot="title">
            <i :class="navMenu.icon"></i>
            <span> {{navMenu.name}}</span>
          </template>
          <!-- 递归 -->
          <NavMenu :navMenus="navMenu.children"></NavMenu>
        </el-submenu>

        <!-- 最后一级菜单 -->
        <el-menu-item v-else
                      :key="navMenu.id"
                      :data="navMenu"
                      :index="navMenu.path">
          <i :class="navMenu.icon"></i>
          <span slot="title">{{navMenu.name}}</span>
        </el-menu-item>
      </div>
    </div>
  </div>
</template>
<!-- 导航模板设置 -->
<script>
  import bus from "./bus";

  export default {
    name: 'NavMenu',
    props: ['navMenus'],
    data() {
      return {
        collapse: false,
      };
    },
    computed: {
      onRoutes() {
        return this.$route.path.replace("/", "");
      },
    },
    created() {
      // 通过 Event Bus 进行组件间通信，来折叠侧边栏
      bus.$on("collapse", msg => {
        this.collapse = msg;
      });
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
    }
  };
</script>
<style scoped>
  @import '../../../assets/css/layout/sidebar.css';
</style>
